import React, { useState, useRef, useEffect } from "react";
import styles from "./assessmentstatus.module.css";
import { useParams } from "react-router-dom";
import axios from "axios";
// import html2pdf from "html2pdf.js/dist/html2pdf.min.js";
import html2pdf from "html2pdf.js";

// Helper: fetch image as base64 string using fetch API (works only if server supports CORS)
const toDataURL = async (url) => {
  try {
    const response = await fetch(
      `https://starbehaviors.com/imageUrl.php?url=${encodeURIComponent(url)}`
    );
    if (!response.ok) throw new Error("Failed to fetch image");

    const data = await response.json();
    return data.base64; // already base64 from PHP
  } catch (e) {
    return url; // fallback
  }
};

// Replace all <img> src attributes with base64 data URLs if possible
const replaceAllImagesWithBase64 = async (container) => {
  const images = container.querySelectorAll("img");
  for (const img of images) {
    const src = img.getAttribute("src");
    if (!src.startsWith("data:")) {
      try {
        const base64Src = await toDataURL(src);
        // Only replace if we got a base64 data URL back

        if (base64Src.startsWith("data:")) {
          img.setAttribute("src", base64Src);
        }
      } catch {
        // Ignore errors silently
      }
    }
  }
};

const UserAssessmentsCertificate = () => {
  const { admincode, id } = useParams();
  console.log("admincode - ", admincode);
  const [assessment, setAssessment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const printRef = useRef();

  useEffect(() => {
    const fetchAssessment = async () => {
      try {
        // 1. Get email from localStorage
        const userEmail = localStorage.getItem("useremail");
        if (!userEmail) {
          setError("No user email found in local storage.");
          setLoading(false);
          return;
        }

        // 2. Call API with email payload
        const response = await axios.post(
          "https://casaahaanahotels.com/assessment_status_by_driver",
          { email: userEmail },
          { headers: { "Content-Type": "application/json" } }
        );

        const data = response.data || [];

        // 3. Match assessment by id param
        const match = data.find(
          (item) => String(item.assessment_id) === String(id)
        );

        if (match) setAssessment(match);
        else setError("No matching assessment found.");
      } catch (err) {
        console.error(err);
        setError("Failed to fetch assessment data.");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchAssessment();
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!assessment) return <p>No assessment data available.</p>;

  const { assessment_id, assessment_type, driver_name, score, timestamp } =
    assessment;
  const formattedDate = new Date(timestamp).toLocaleDateString("en-US");

  const CertificateTemplate = () => {
    if (score === 3) {
      return (
        <>
          <h3 style={{ textAlign: "center" }}>
            Certificate of Completion & Achievement
          </h3>
          <p style={{ textAlign: "center" }}>
            This certifies that <b>{driver_name}</b>
          </p>
          <p style={{ textAlign: "center" }}>
            has successfully completed the Star Behaviors™ {assessment_type}{" "}
            through the StarLogic™ Platform.
          </p>
          <center>
            <img
              src={`https://starbehaviors.com/uploadimage/${score}.png`}
              alt="Star Score"
              style={{ display: "block", margin: "auto", maxWidth: "100%" }}
            />
            <p>
              <b>Awarded Score: {score} of 5</b>
            </p>
          </center>
          <p style={{ textAlign: "center" }}>
            This achievement reflects a strong foundation of the Qualities, Core
            Values, and Behaviors essential to success in the transportation and
            logistics industry. A 3-Star score demonstrates readiness and
            potential for continued growth and development.
          </p>
        </>
      );
    }
    if (score === 4) {
      return (
        <>
          <h3 style={{ textAlign: "center" }}>
            Certificate of Completion & Achievement
          </h3>
          <p style={{ textAlign: "center" }}>
            This certifies that <b>{driver_name}</b>
          </p>
          <p style={{ textAlign: "center" }}>
            has successfully completed the Star Behaviors™ {assessment_type}{" "}
            through the StarLogic™ Platform.
          </p>
          <center>
            <img
              src={`https://starbehaviors.com/uploadimage/${score}.png`}
              alt="Star Score"
              style={{ display: "block", margin: "auto", maxWidth: "100%" }}
            />
            <p>
              <b>Awarded Score: {score} of 5</b>
            </p>
          </center>
          <p style={{ textAlign: "center" }}>
            This recognition reflects proven alignment with the Qualities, Core
            Values, and Behaviors that drive performance, reliability, and
            long-term success in the transportation and logistics industry.
          </p>
        </>
      );
    }
    if (score === 5) {
      return (
        <>
          <h3 style={{ textAlign: "center" }}>
            Certificate of Completion & Achievement
          </h3>
          <p style={{ textAlign: "center" }}>
            This certifies that <b>{driver_name}</b>
          </p>
          <p style={{ textAlign: "center" }}>
            has successfully completed the Star Behaviors™ {assessment_type}{" "}
            through the StarLogic™ Platform.
          </p>
          <center>
            <img
              src={`https://starbehaviors.com/uploadimage/${score}.png`}
              alt="Star Score"
              style={{ display: "block", margin: "auto", maxWidth: "100%" }}
            />
            <p>
              <b>Awarded Score: {score} of 5</b>
            </p>
          </center>
          <p style={{ textAlign: "center" }}>
            This distinction is reserved for those who demonstrate exceptional
            alignment with the Qualities, Core Values, and Behaviors that define
            the very best in the transportation and logistics industry. A 5-Star
            score is a rare and elite recognition of excellence, commitment, and
            future leadership potential.
          </p>
        </>
      );
    }
    return (
      <p style={{ textAlign: "center" }}>
        Certificate not available for this score.
      </p>
    );
  };

  // const handleDownloadPDF = async () => {
  //   await replaceAllImagesWithBase64(printRef.current);
  //   const opt = {
  //     margin: 0.3,
  //     filename: certificate-${assessment_id}.pdf,
  //     image: {{ type: "jpeg", quality: 0.98} },
  //     html2canvas: { useCORS: true, allowTaint: true, scale: 2 },
  //     jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
  //   };
  //   html2pdf().set(opt).from(printRef.current).save();
  // };

  const handleDownloadPDF = async () => {
    // Convert all images inside the ref element to base64
    await replaceAllImagesWithBase64(printRef.current);

    const opt = {
      margin: 0.3,
      filename: `certificate-${assessment_id}.pdf`, // fixed template literal
      image: { type: "jpeg", quality: 0.98 }, // fixed object syntax
      html2canvas: { useCORS: true, allowTaint: true, scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    html2pdf().set(opt).from(printRef.current).save();
  };

  console.log("assessments certificate = ", assessment);
  console.log("admincode = ", admincode);
  console.log("id = ", id);
  return (
    <div
      className={`${styles.container} ${styles.certificate_con}`}
      // style={{
      //   padding: "0px",
      //   position: "relative",
      //   margin: "0",
      //   display: "flex",
      //   flexDirection: "row",
      //   justifyContent: "space-evenly",
      //   alignContent: "center",
      //   maxWidth: "100%",
      //   gap: "30px",
      // }}
    >
      <div className={`${styles.certificat_download_btn}`}>
        <button
          type="button"
          onClick={handleDownloadPDF}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px 20px",
            background: "linear-gradient(90deg, #002855  , #002855 )",
            color: "#fff",
            fontWeight: "bold",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
            transition: "all 0.3s ease",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.transform = "translateY(-2px) scale(1.02)")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.transform = "translateY(0) scale(1)")
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M.5 9.9V14a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V9.9a.5.5 0 0 0-1 0V14H1.5V9.9a.5.5 0 0 0-1 0z" />
            <path d="M7.646 10.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 1 0-.708-.708L8.5 9.293V1.5a.5.5 0 0 0-1 0v7.793L5.354 7.146a.5.5 0 1 0-.708.708l3 3z" />
          </svg>
          Download Certificate
        </button>
      </div>
      <div
        ref={printRef}
        style={{
          width: "96%",
          // margin: "30px auto",
          marginTop: "30px",
          background: "#fff",
          padding: "20px",
          boxShadow: "0 0 15px rgba(0,0,0,0.2)",
          borderRadius: "8px",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <img
            src="https://starbehaviors.com/uploadimage/star_behaviors_llc_cover.jpeg"
            alt="Star Behaviors Logo"
            className={styles.certificateLogo}
            style={{ margin: "0 auto" }}
          />
        </div>
        <div style={{ marginTop: "20px", lineHeight: 1.6 }}>
          <CertificateTemplate />
          <p style={{ textAlign: "center", marginTop: "15px" }}>
            Date: {formattedDate}
          </p>
          <p style={{ textAlign: "center" }}>Certificate ID: {assessment_id}</p>
          <p
            style={{
              textAlign: "center",
              fontStyle: "italic",
              marginTop: "20px",
            }}
          >
            “It’s in the Stars. Your future starts with knowing your strengths.”
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserAssessmentsCertificate;
